<template>
    <ScreenLayout ref="screenLayout">

        <template slot="header">
            <v-toolbar flat dark dense class="primary" xxstyle="z-index:8;position:fixed;">
                    
                <v-btn @click.native="$router.push('/home')" icon>
                    <v-icon>chevron_left</v-icon>
                </v-btn>        
                <v-toolbar-title>
                    <span @click="showTeamDetails(activeTeam)" class="clickable heading-button">{{activeTeam.name}}</span>
                    <span v-if="activeTeam.name && activeCollection.name">></span>
                    <span @click="showCollectionDetails(activeCollection)" class="clickable heading-button">{{activeCollection.name}}</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <!-- <v-btn icon>
                    <v-icon>search</v-icon>
                </v-btn> -->
                <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                    <v-icon v-on="on">more_vert</v-icon>
                    </template>
                    <v-list>
                        <v-list-item @click="showBulkUpdate">
                            <v-list-item-title>Bulk Update</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-btn @click="rightColumnActive = !rightColumnActive" icon>
                    <v-icon>more_vert</v-icon>
                </v-btn>
            </v-toolbar>
        </template>
    
        <template slot="left">
            <v-select @change="selectTeam" :value="teamId" :items="[...teamsItems, {value:'add', text: 'Add New Team'} ]" class="ma-2" single-line/>
            
            <v-list two-line subheader>             
    
            <v-list-item v-for="collection in collections" :key="collection._id" @click="selectCollection(collection)" >
                <v-list-item-avatar>
                <v-icon>folder</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                <v-list-item-title>{{ collection.name }}</v-list-item-title>
                <v-list-item-subtitle>Collection</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                <v-btn icon ripple>
                    <v-icon color="grey lighten-1">info</v-icon>
                </v-btn>
                </v-list-item-action>
            </v-list-item>
            </v-list>
            <div style="text-align:center;">
                <v-btn icon small color="grey lighten-2" @click="showCollectionDetails(null)" >
                    <v-icon>add</v-icon>
                </v-btn>                 
            </div> 
        </template>

        <!-- <div class="elevation-3 white-background ma-3 pa-3">
            <v-btn @click="showCollectionDetails(activeCollection)">Modify Collection</v-btn>
        </div> -->

        <!-- Fields -->

        <div class="elevation-3 ma-3">
            <div class="white-background pa-3" style="position:relative">
                 <span class="heading">Fields</span>
                 <v-btn @click="showFieldDetails(null)" fab absolute small right bottom color="primary">
                     <v-icon>add</v-icon>
                 </v-btn>
            </div>
            <div class="light-background pa-3">
               
                <div v-for="field in collection.fields" @click="showFieldDetails(field)" class="field hoverable clickable" :key="field._id">
                    {{field.name}} - <flag>{{field.type}}</flag>
                </div>
            </div>
        </div>

        <!-- Data  -->

        <div class="elevation-3 ma-3">
            <div class="white-background pa-3" style="position:relative">
                 <span class="heading">Data</span>
                 <v-text-field label="Search" v-model="searchText" />
                 <v-btn @click="showDataDetails(null, collection.fields)" fab absolute small right bottom color="primary">
                     <v-icon>add</v-icon>
                 </v-btn>
            </div>
            <div class="light-background pa-3">
                <table class="full-width" style="border-collapse:collapse">
                    <tr style="font-weight:bold">
                        <td v-for="field in collection.fields">{{field.name}}</td>
                    </tr>
                    <tr v-for="row in collection.data" @click="showDataDetails(row, collection.fields)" class="clickable hoverable">
                        <td v-for="field in collection.fields">
                            <div style="max-height:60px;overflow:auto;min-width:60px;">
                                <Merger :row="row" :field="field" />
                            </div>
                            <!-- <div style="max-height:50px;overflow:auto;min-width:60px;" v-html="getRowField(row, field)"></div> -->
                        </td>  
                    </tr>
                </table>
             
            </div>
        </div>

        <!-- Actions  -->

        <div class="elevation-3 ma-3">
            <div class="white-background pa-3" style="position:relative">
                 <span class="heading">Actions</span>
                 <v-btn @click="showActionDetails(null)" fab absolute small right bottom color="primary">
                     <v-icon>add</v-icon>
                 </v-btn>
            </div>
            <div class="light-background pa-3">
                <table class="full-width" style="border-collapse:collapse">
                    <tr style="font-weight:bold">
                        <td>Name</td>
                        <td>Field</td>
                        <td>Type</td>
                    </tr>
                    <tr v-for="action in collection.actions" @click="showActionDetails(action)" class="clickable hoverable" :key="action._id">
                        <td>{{action.name}}</td>  
                        <td>{{action.field}}</td>  
                        <td>{{action.type}}</td>  
                    </tr>
                </table>
             
            </div>
        </div>

        <template slot="right">
 
                   
        </template>

        <TeamDialog :settings="teamDialog.settings" :team="teamDialog.team" @save="saveTeam" />
        <CollectionDialog :settings="collectionDialog.settings" :collection="collectionDialog.collection" @save="saveCollection" />
        <FieldDialog :settings="fieldDialog.settings" :field="fieldDialog.field" @save="saveField" @delete="deleteField" />
        <ActionDialog :settings="actionDialog.settings" :action="actionDialog.action" @save="saveAction" @delete="deleteAction" />
        <DataDialog :settings="dataDialog.settings" :row="dataDialog.row" :fields="dataDialog.fields" @save="saveData" @delete="deleteData" />
        <BulkUpdateDialog v-if="bulkUpdateDialog.settings.visible" :settings="bulkUpdateDialog.settings" />

    </ScreenLayout>
</template>

<script>

import AsyncComputed from 'vue-async-computed'
import Flag from '@/ui-elements/Flag'

import LayoutContainer2 from '@/ui-elements/LayoutContainer2'
import SectionLayout from '@/screens/SectionLayout'
import ElementLayout from '@/screens/ElementLayout'
import LayoutReadOnly from '@/ui-elements/LayoutReadOnly'
import ElementMenu from '@/screens/ElementMenu'
import ScrollHelpers from '../helpers/ScrollHelpers'
import ScreenLayout from '../screens/ScreenLayout'
import PageLayout from '../screens/PageLayout'
import VueJsonToCsv from 'vue-json-to-csv'
import TeamDialog from './TeamDialog'
import CollectionDialog from './CollectionDialog'
import FieldDialog from './FieldDialog'
import ActionDialog from './ActionDialog'
import DataDialog from './DataDialog'

import DateRangeList from '@/ui-elements/DateRangeList'
import Merger from '@/ui-elements/Merger'
import ScreenData from '@/screens/ScreenData'
import ScreenTable from '@/screens/ScreenTable'
import BulkUpdateDialog from './BulkUpdateDialog'
import Utilities from '../helpers/Utilities'
import StringHelpers from '../helpers/StringHelpers'
import DataHelpers from '../helpers/DataHelpers'
import DateHelpers from '../helpers/DateHelpers'
import LookupData from '../helpers/LookupData'
import TemplateHelpers from '../helpers/TemplateHelpers'
import ArrayHelpers from '../helpers/ArrayHelpers'
import RouterHelpers from '../helpers/RouterHelpers'
import AlertHelpers from '../helpers/AlertHelpers'
import MergeHelpers from '../helpers/MergeHelpers'
import EmailHelpers from '../helpers/EmailHelpers'
import FireData from '../data/FireData'
import NiceData from '../data/NiceData'
import Data4 from '../data/Data4'
import Firestore from '../data/Firestore'

class PageSection {
    constructor(section) { 
        this.section = section
    }
    fieldByName(name) {
        return this.section.fields.find(o => o.name == name) || null
    }
}



export default {
    data() {
        return {

            searchText: '',
            db: {},

            teams: [],
            collections: [],

            //to remove..
            teams: [],
            tables: [],

            teamDialog: {
                settings: {
                    visible: false,
                    title: 'New Team'
                },
                team: {

                }
            },

            collectionDialog: {
                settings: {
                    visible: false,
                    title: 'New Collection'
                },
                collection: {

                }
            },
            bulkUpdateDialog: {
                settings: {
                    visible: false,
                    title: 'Bulk Update'
                },
                collection: {

                }
            },

            fieldDialog: {
                settings: {
                    visible: false,
                    title: null,
                },
                field: {

                }
            },

            actionDialog: {
                settings: {
                    visible: false,
                    title: null,
                },
                action: {
                    operation: ['Create', 'Update']
                }
            },
            dataDialog: {
                settings: {
                    visible: false,
                    title: null,
                },
                row: {

                },
                fields: []
            },          
        }
    },

    components: {
        ScreenLayout,
        TeamDialog,
        CollectionDialog,
        FieldDialog,
        ActionDialog,
        DataDialog,
        BulkUpdateDialog,
        Flag,
        Merger,
    },
    
    props: {
        teamId: String,
        collectionId: String,
    },

    computed: {


        collection() {
            return this.$store.getters.getCollection(this.teamSlug, this.collectionSlug)
        },
        
        pageTitle() {
            return ( 
                (this.activeTeam.name || '') 
                + (this.activeTeam.name && this.activeCollection.name ? ' - ' : '') 
                + (this.activeCollection.name || '')
            ) || 'Taco'
        },

        activeCollection() {
            return this.collections.find(o => o._id == this.collectionId) || {}
        },

        activeTeam() {
            return this.teams.find(o => o._id == this.teamId) || {}
        },

        teamSlug() {
            return StringHelpers.toCamelCase(this.activeTeam.name) || 'nullTeam'
        },
        collectionSlug() {
            return StringHelpers.toCamelCase(this.activeCollection.name) || 'nullCollection'
        },


        teamsItems() {
            return this.teams.map(o => {
                return {text: o.name, value:o._id}
            })
        },

        collectionsListRef() {
            let ref = Firestore.getTeamRef(this.teamSlug).collection('collections')
            ref.storePath = true
            return ref
        },

        collectionRef() {
            return Firestore.getCollectionDocumentRef(this.teamSlug, this.collectionSlug)
        },

        fieldsRef() {  
            let ref = this.collectionRef.collection('fields')
            ref.storePath = true
            return ref
        },

        dataRef() {
            return this.collectionRef.collection('data')
        }   

    },

    methods: {

        loadTeams() {
            let ref = Firestore.getFirestore().collection('teams')
            Firestore.streamCollection(ref, this.teams)
        },

        loadCollections() {
            if(this.teamSlug == 'nullteam')
                return
            Firestore.streamCollection(this.collectionsListRef, this.collections)
        },

        loadCollection() {
            
            Firestore.streamToStore(this.teamSlug, this.collectionSlug)
        },

        selectCollection(collection) {
            RouterHelpers.setQueryParameter(this, 'c', collection._id)
        },

        selectTeam(teamId) {
            
            if(teamId == 'add') {
                this.showTeamDetails(null)
                return
            }

            RouterHelpers.setQueryParameter(this, 't', teamId)
        },

        showTeamDetails(team) {
            this.teamDialog.team = {...team}
            this.teamDialog.settings.title = this.teamDialog.team.name || 'Add a Team'
            this.teamDialog.settings.visible = true
        },

        saveTeam(team) {
            console.log('saving', team)
            team._path = 'teams'
            team._id = team._id || team.name
            Firestore.saveItem(team)
        },

        showCollectionDetails(collection) {
            this.collectionDialog.collection = {...collection}
            this.collectionDialog.settings.title = this.collectionDialog.collection.name || 'Add a Collection'

            this.collectionDialog.settings.visible = true
        },

        saveCollection(collection) {
            console.log('saving', collection)
            collection._path = collection._path || `teams/${this.teamSlug}/collections`
            collection._id = collection._id || collection.name
            Firestore.saveItem(collection)
        },



        showFieldDetails(field) {
            this.fieldDialog.settings.title = (field ? 'Modify Field' : 'New Field')
            this.fieldDialog.field = {...field}
            this.fieldDialog.field._path = this.fieldDialog.field._path || `teams/${this.teamSlug}/collections/${this.collectionSlug}/fields`
            this.fieldDialog.settings.visible = true
        },

        saveField(field) {
            console.log('saving', field)
            Firestore.saveItem(field)
        },

        deleteField(field) {
            Firestore.deleteItem(field)
        },

        showActionDetails(action) {
            this.actionDialog.settings.title = (action ? 'Modify Action' : 'New Action')
            this.actionDialog.action = {...action}
            this.actionDialog.action._path = this.actionDialog.action._path || `teams/${this.teamSlug}/collections/${this.collectionSlug}/actions`
            this.actionDialog.settings.visible = true
        },

        saveAction(action) {
            console.log('saving', action)
            Firestore.saveItem(action)
        },

        deleteAction(action) {
            Firestore.deleteItem(action)
        },

        showDataDetails(row, fields) {
            this.dataDialog.settings.title = (row ? 'Modify Record' : 'New Record')
            this.dataDialog.row = Firestore.cloneForEdit(row)// {...row}
            this.dataDialog.row._path = this.dataDialog.row._path || `teams/${this.teamSlug}/collections/${this.collectionSlug}/data`
            this.dataDialog.fields = fields
            this.dataDialog.settings.visible = true
        },        

        saveData(record) {
            console.log('Saving Data...', record)
            Firestore.saveAndAction(record)
        },

        deleteData(row) {
            console.log('dltng')
            Firestore.deleteItem(row)
        },

        showBulkUpdate() {

        }
    },

    watch: {
        activeTeam: {
            handler: function(val, oldVal) {
                this.loadCollections()
            }
        },
        activeCollection: {
            handler: function(val, oldVal) {
                this.loadCollection()
            }
        }
    },

    created() {
        this.loadTeams()
        this.loadCollections()
        DataHelpers.fetchUser().then(user => {
            console.log('logged in as id', DataHelpers.getUserId())
        })
    }

}
</script>

<style scoped>
.field {
    padding:10px;margin:6px;border-radius:5px;border:solid 1px #ddd;
}
td {
    padding:8px;border-bottom:solid 1px #ccc;
}
.faded {
    color: #bbb;
}

</style>




// WEBPACK FOOTER //
// SystemEditor.vue?41e7ddeb